export enum ListsType {
	SOURCE_LIST = 'source_list',
	TARGET_LIST = 'target_list'
}

export interface TransferItemList {
	id: number;
	title: string;
}
